import { AnonymousStudentServiceReady } from '@studyportals/anonymous-student-interfaces';
import {
	ISubscriber,
} from '@studyportals/event-aggregation-service-interface';

import { EventAggregationService } from '@/utils/event-aggregation-service';
import { AuthenticationServiceReadyEvent } from '@studyportals/authentication-service-interfaces';
import { BestfitOverviewReadyEvent } from '@studyportals/bestfit-overview-interfaces';
import { ProfileQuestionnairesReadyEvent } from '@studyportals/profile-questionnaires-interfaces';
import globals from '@/utils/globals';
import { SessionServiceReadyEvent } from '@studyportals/student-interfaces';
import { CopilotServiceApplication } from '@/application/copilot-service-application';


export default class DependencyCheckerPlugin implements ISubscriber<ProfileQuestionnairesReadyEvent |
BestfitOverviewReadyEvent |
AnonymousStudentServiceReady |
AuthenticationServiceReadyEvent |
SessionServiceReadyEvent> {
	private isProfileQuestionnairesReady = false;
	private isBestfitOverviewReady = false;
	private isAnonymousStudentServiceReady = false;
	private isAuthenticationServiceReady = false;
	private isSessionServiceReady = false;

	public initialize(): void {
		EventAggregationService.instance?.subscribeTo(ProfileQuestionnairesReadyEvent.EventType, this, true);
		EventAggregationService.instance?.subscribeTo(BestfitOverviewReadyEvent.EventType, this, true);
		EventAggregationService.instance?.subscribeTo(AnonymousStudentServiceReady.EventType, this, true);
		EventAggregationService.instance?.subscribeTo(SessionServiceReadyEvent.EventType, this, true);
		EventAggregationService.instance?.subscribeTo(AuthenticationServiceReadyEvent.EventType, this, true);
	}

	public async notify(event: ProfileQuestionnairesReadyEvent |
	BestfitOverviewReadyEvent |
	AnonymousStudentServiceReady |
	AuthenticationServiceReadyEvent |
	SessionServiceReadyEvent
	): Promise<void> {
		switch (event.eventType) {

		case ProfileQuestionnairesReadyEvent.EventType:
			this.handleProfileQuestionnairesReadyEvent(event as ProfileQuestionnairesReadyEvent);
			break;
		case BestfitOverviewReadyEvent.EventType as string:
			this.handleBestfitOverviewReadyEvent(event as BestfitOverviewReadyEvent);
			break;
		case AnonymousStudentServiceReady.EventType:
			this.handleAnonymousStudentServiceReady(event as AnonymousStudentServiceReady);
			break;
		case AuthenticationServiceReadyEvent.EventType:
			this.handleAuthenticationServiceReadyEvent(event as AuthenticationServiceReadyEvent);
			break;
		case SessionServiceReadyEvent.EventType:
			this.handleSessionServiceReadyEvent(event as SessionServiceReadyEvent);
			break;
		}

		if (!this.isReadyToRender) return;
		await CopilotServiceApplication.Store.actions.setAreDependenciesLoaded(true);
	}


	private handleAuthenticationServiceReadyEvent({ authenticationServiceApplication }: AuthenticationServiceReadyEvent): void {
		globals.authenticationServiceApplication = authenticationServiceApplication;
		this.isAuthenticationServiceReady = true;
	}

	private handleSessionServiceReadyEvent({ sessionService }: SessionServiceReadyEvent): void {
		globals.sessionService = sessionService;
		this.isSessionServiceReady = true;
	}


	private handleProfileQuestionnairesReadyEvent({ profileQuestionnairesApplication }: ProfileQuestionnairesReadyEvent): void {
		globals.profileQuestionnaireApplication = profileQuestionnairesApplication;
		this.isProfileQuestionnairesReady = true;
	}

	private handleBestfitOverviewReadyEvent({ bestfitOverviewApplication }: BestfitOverviewReadyEvent): void {
		globals.bestFitOverviewApplication = bestfitOverviewApplication;
		this.isBestfitOverviewReady = true;
	}

	private handleAnonymousStudentServiceReady({ anonymousStudentService }: AnonymousStudentServiceReady): void {
		globals.anonymousStudentService = anonymousStudentService;
		this.isAnonymousStudentServiceReady = true;
	}


	private get isReadyToRender(): boolean {
		return this.isProfileQuestionnairesReady &&
			this.isBestfitOverviewReady &&
			this.isAnonymousStudentServiceReady &&
			this.isAuthenticationServiceReady &&
			this.isSessionServiceReady;
	}
}
